module.exports = __webpack_public_path__ + "static/media/dog-dalmation.66ef0605.png";